import React from "react";
import numeral from "numeral";
import BookingFlowTotal from "../BookingFlowTotal";

export default class BookingTermsSection extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="ReviewAndBookSection custom-terms-div col-sm-12">
        <BookingFlowTotal {...this.props} />
      </div>
    );
  }

  renderHeader() {
    return (
      <div>
        <h3>{I18n.t("booking_summary")}</h3>
      </div>
    );
  }

  renderBody() {
    return (
      <div className="expand-collapse-body">
        <form onSubmit={this.props.onBookNow}>
          <div className="YourReservation">
            <BookingFlowTotal {...this.props} />
          </div>
        </form>
      </div>
    );
  }

  renderCollapsedDetail() {
    if (
      this.props.reservation_segments &&
      this.props.reservation_segments.length > 0
    ) {
      return (
        <div className="collapsed-detail">
          <h5 style={{ display: "inline-block" }}>
            <strong>
              {I18n.t("reservation_total")}: {this.props.currency.symbol}
              {numeral(
                (this.props.reservation.total_amount *
                  this.props.currency.exchange_rate) /
                  100
              ).format(this.props.number_format)}
              &nbsp;
            </strong>
          </h5>
          <p style={{ display: "inline-block" }}>
            {I18n.t("with_taxes_and_fees")}
          </p>
          <h5>
            <strong>
              {I18n.t("due_today")}: {this.props.currency.symbol}
              {numeral(
                (this.props.reservation.amount_due_at_booking *
                  this.props.currency.exchange_rate) /
                  100
              ).format(this.props.number_format)}
            </strong>
          </h5>
        </div>
      );
    }
  }

  /**
   * Helper functions
   */

  calculateGuestFees() {
    var total = 0;

    for (
      var i = 0, ilen = this.props.reservation_segments.length;
      i < ilen;
      i++
    ) {
      var reservation_segment = this.props.reservation_segments[i];
      if (
        reservation_segment.rate.rate_guest_types &&
        reservation_segment.rate.rate_guest_types.length
      ) {
        for (
          var j = 0, jlen = reservation_segment.rate.rate_guest_types.length;
          j < jlen;
          j++
        ) {
          var rate_guest_type = reservation_segment.rate.rate_guest_types[j];
          for (var k = 0, klen = this.props.guests.length; k < klen; k++) {
            var guest_type = this.props.guests[k];
            if (guest_type.id == rate_guest_type.guest_type_id) {
              if (
                guest_type.number_of_guests > rate_guest_type.guests_included
              ) {
                if (rate_guest_type.frequency == "recurring") {
                  var duration = reservation_segment.end_date.diff(
                    reservation_segment.start_date,
                    "days"
                  );
                  total =
                    total +
                    (guest_type.number_of_guests -
                      rate_guest_type.guests_included) *
                      rate_guest_type.additional_guest_price_amount *
                      duration;
                } else if (rate_guest_type.frequency == "one_time") {
                  total =
                    total +
                    (guest_type.number_of_guests -
                      rate_guest_type.guests_included) *
                      rate_guest_type.additional_guest_price_amount;
                }
              }
            }
          }
        }
      }
    }

    return total;
  }

  calculateSubtotalAmount() {
    var total = 0;
    for (
      var i = 0, ilen = this.props.reservation_segments.length;
      i < ilen;
      i++
    ) {
      var reservation_segment = this.props.reservation_segments[i];
      for (
        var j = 0, jlen = reservation_segment.rate.dates.length;
        j < jlen;
        j++
      ) {
        total = total + reservation_segment.rate.dates[j].amount;
      }
    }
    return total;
  }

  calculateTaxesAndFeesAmount() {
    var total = 0;
    for (
      var i = 0, ilen = this.props.reservation_segments.length;
      i < ilen;
      i++
    ) {
      var reservation_segment = this.props.reservation_segments[i];
      for (
        var j = 0, jlen = reservation_segment.rate.dates.length;
        j < jlen;
        j++
      ) {
        total =
          total +
          reservation_segment.rate.dates[j].taxes_and_fees_amount +
          this.calculateGuestFees();
      }
    }
    return total;
  }
}
